<template>
  <form class="form form-user-password" @submit.prevent="postPassword">
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Aktualne hasło</label>
        <div class="input-wrapper">
          <input v-model="form.current_password"
                 type="password"
                 :class="{'input-error' : errors.current_password }"
                 placeholder="Podaj aktualne hasło"
                 ref="currentPasswordInput"
                 required/>
        </div>
        <p class="error" v-if="errors.current_password">{{ errors.current_password[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Nowe hasło</label>
        <div class="input-wrapper">
          <input v-model="form.new_password"
                 type="password"
                 :class="{'input-error' : errors.new_password }"
                 placeholder="Podaj nowe hasło"
                 ref="newPasswordInput"
                 required/>
        </div>
        <p class="error" v-if="errors.new_password">{{ errors.new_password[0] }}</p>
        <p class="text-small text-gray-light">Hasło powinno zawierać: jedną wielką literę, jedną małą literę,
          jedną cyfrę lub znak specjalny i min. 8 znaków.</p>
      </div>
    </slide-x-left-transition>
    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Zapisz</span>
    </ion-button>
  </form>
</template>

<script>
  import goTo from '@/mixins/goto';
  import api from '@/services/Api';
  import {mapState} from "vuex";

  function getDefaultFormData() {
    return {
      current_password: '',
      current_password: ''
    }
  }

  export default {
    name: 'FormChangePassword',
    mixins: [goTo],
    computed: {
      ...mapState({
        loading: state => state.profile.loading,
        errors: state => state.profile.errors
      })
    },
    data() {
      return {
        show: false,
        form: getDefaultFormData()
      }
    },
    mounted(){
      this.show = true;
      setTimeout(() => {
        this.$refs.currentPasswordInput.focus();
      },1000)
    },
    methods: {
      postPassword() {
        this.$store.dispatch('profile/UPDATE_PROFILE_PASSWORD_REQUEST', this.form).then(resp => {
          this.goBack()
        })
      }
    }
  }
</script>